


















































import { BvEvent } from 'bootstrap-vue';
import Vue, { PropType } from 'vue';
import Spinner from './Spinner.vue';
import CustomButton from '../components/Button.vue';
import InlineGroup from '../components/InlineGroup.vue';

export interface RefreshObj {
  page?: number,
}

interface Data {
  page?: number,
  inputPage?: number,
}

export default Vue.extend({
  props: {
    isLoading: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    totalItems: Number as PropType<number | undefined>,
    currentPage: Number as PropType<number | undefined>,
    pageItems: Number as PropType<number | undefined>,
  },
  data: (): Data => ({
    page: undefined,
    inputPage: undefined,
  }),
  components: {
    Spinner,
    CustomButton,
    InlineGroup,
  },
  created() {
    this.page = this.currentPage;
  },
  watch: {
    currentPage() {
      this.page = this.currentPage;
    },
    page() {
      this.inputPage = this.page;
    }
  },
  methods: {
    changePage(page: number) {
      this.refresh(page);
    },
    paginationPageChange(_: BvEvent, page: number) {
      this.changePage(page);
    },
    refresh(page?: number) {
      this.$emit('refresh', {
        page,
      });
    },
    inputPageKeydown(event: KeyboardEvent) {
      if (this.inputPage && event.key === 'Enter')
        this.changePage(this.inputPage);
    }
  }
});

